<template>

  <card titulo="Informações Regulatórias" v-if="hasLivro2 || hasLivro3">
    <card-content class="mb-2" :background="true">
      <div class="row gutters-xs">

        <v-input v-if="mostrarBlocoIndicadorReal && !itn003SemClassificacaoConfigurada"
                 type="select" class="col-4" label="Classificação Ato - ITN 003"
                 :disabled="!edicao || (itn003IsFixa && !itn003FixaObsoleta)"
                 v-model="ato.classificacaoAtoItn003"
                 :options="itn003Options" />

        <v-input v-if="mostrarBlocoIndicadorReal && ato.classificacaoAtoItn003 === 'TRANSMISSAO_AQUISICAO_ORIGINARIA'"
                 type="select" class="col-8" label="Transmissão/Aquisição Originária de Direitos Reais"
                 :disabled="!edicao || (itn003IsFixa && !itn003FixaObsoleta && !transmissaoFixaObsoleta && !transmissaoPodeEditar)"
                 v-model="ato.transmissaoAquisicaoOriginaria" :required="true"
                 :options="transmissaoOptions" />

        <v-input v-if="ato.classificacaoAtoItn003 === 'ALTERACAO_IMOVEL'"
                 type="select" class="col-6" label="Alteração do Imóvel" :required="true"
                 :disabled="!edicao || (itn003IsFixa && !itn003FixaObsoleta && !alteracaoFixaObsoleta && !alteracaoPodeEditar)"
                 v-model="ato.alteracaoImovelItn003"
                 :options="alteracaoOptions" />

        <v-input v-if="exibirAutorizacaoIncra"
                 type="radio" class="col-6" label="A aquisição do imóvel por estrangeiro possui autorização do INCRA?"
                 :disabled="!edicao"
                 v-model="ato.autorizacaoIncra" />

        <div class="w-100"></div>

        <select-lna-srei v-if="hasLivro2"
                         class="col-6" :livro="2"
                         :disabled="itn004Livro2IsDisabled"
                         :allowed-codes="itn004Livro2AllowedCodes"
                         label="Classificação Ato Livro 2 – ITN 004"
                         :clearable="false"
                         v-model="ato.classificacaoAtoItn004Livro2" />
        <div v-if="hasLivro2 && isAtoGenericoLivro2" class="col-6" :class="{'is-disabled-cursor': itn004Livro2IsDisabled}">
          <v-input type="text" label="Denominação Complementar"
                   :disabled="itn004Livro2IsDisabled"
                   v-model="ato.denominacaoComplementarItn004Livro2" />
        </div>

        <div class="w-100"></div>

        <select-lna-srei v-if="hasLivro3"
                         class="col-6" :livro="3"
                         :disabled="itn004Livro3IsDisabled"
                         :allowed-codes="itn004Livro3AllowedCodes"
                         label="Classificação Ato Livro 3 – ITN 004"
                         :clearable="false"
                         v-model="ato.classificacaoAtoItn004Livro3" />
        <div v-if="hasLivro3 && isAtoGenericoLivro3" class="col-6" :class="{'is-disabled-cursor': itn004Livro3IsDisabled}">
          <v-input type="text" label="Denominação Complementar"
                   :disabled="itn004Livro3IsDisabled"
                   v-model="ato.denominacaoComplementarItn004Livro3" />
        </div>

      </div>
    </card-content>
  </card>

</template>

<script>
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import SelectLnaSrei from "@/components/Form/SelectLnaSrei.vue";
import AtoBusiness from "@/business/protocolo/AtoBusiness.js";

const transmissaoBaseOptions = [
  { id: 'COMPRA_E_VENDA', nome: '1 - Compra e Venda' },
  { id: 'ARREMATACAO', nome: '2 - Arrematação' },
  { id: 'CISAO_TOTAL_PJ', nome: '3 - Cisão Total de Pessoa Jurídica' },
  { id: 'CISAO_PARCIAL_PJ', nome: '4 - Cisão Parcial de Pessoa Jurídica' },
  { id: 'DACAO_EM_PAGAMENTO', nome: '5 - Dação em pagamento' },
  { id: 'DOACAO', nome: '6 - Doação' },
  { id: 'FUSAO_PJ', nome: '7 - Fusão de Pessoa Jurídica' },
  { id: 'INTEGRALIZACAO_CAPITAL', nome: '8 - Integralização de capital social/Incorporação Societária' },
  { id: 'PARTILHA_ADJUDICACAO_OBITO', nome: '9 - Partilha/Adjudicação por Óbito' },
  { id: 'PARTILHA_DIVORCIO', nome: '10 - Partilha por divórcio' },
  { id: 'PARTILHA_DISSOLUCAO_UNIAO', nome: '11 - Partilha por dissolução de união estável' },
  { id: 'PARTILHA_SEPARACAO', nome: '12 - Partilha por separação' },
  { id: 'PARTILHA_NULIDADE_CASAMENTO', nome: '13 - Partilha por nulidade ou anulação do casamento' },
  { id: 'PERMUTA', nome: '14 - Permuta' },
  { id: 'PROMESSA_COMPRA_E_VENDA', nome: '15 - Promessa de compra e venda' },
  { id: 'OUTRAS_NAO_ONEROSAS', nome: '16 - Outras não onerosas' },
  { id: 'OUTRAS_ONEROSAS', nome: '17 - Outras onerosas' },
  { id: 'USUCAPIAO', nome: '18 - Usucapião' },
  { id: 'NAO_SE_APLICA', nome: '19 - Não se aplica' },
];

const alteracaoBaseOptions = [
  { id: 'ALUVIAO', nome: '1 - Aluvião' },
  { id: 'AVULSAO', nome: '2 - Avulsão' },
  { id: 'DESDOBRO', nome: '3 - Desdobro' },
  { id: 'DESMEMBRAMENTO', nome: '4 - Desmembramento' },
  { id: 'DIVISAO', nome: '5 - Divisão' },
  { id: 'ESTREMACAO', nome: '6 - Estremação' },
  { id: 'FORMACAO_DE_ILHA', nome: '7 - Formação de ilha' },
  { id: 'LOTEAMENTO', nome: '8 - Loteamento' },
  { id: 'REGULARIZACAO_FUNDIARIA', nome: '9 - Regularização fundiária' },
  { id: 'RETIFICACAO', nome: '10 - Retificação' },
  { id: 'UNIFICACAO', nome: '11 - Unificação' },
  { id: 'OUTRO', nome: '12 - Outro' },
];

const SUFIXO_CLASSIFICACAO_ITN004_GENERICA = '999';

export default {
  name: "InformacoesRegulatorias",
  components: { Card, CardContent, SelectLnaSrei },
  props: ['ato', 'edicao', 'protocolo', 'ficha', 'item', 'nome'],

  computed: {
    itn003FixaObsoleta() {
      if (!this.itn003IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn003;
      return fixa != null && this.ato?.classificacaoAtoItn003 != null
        && this.ato.classificacaoAtoItn003 !== fixa;
    },

    transmissaoFixaObsoleta() {
      if (!this.itn003IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.transmissaoAquisicaoOriginaria;
      return fixa != null && this.ato?.transmissaoAquisicaoOriginaria != null
        && this.ato.transmissaoAquisicaoOriginaria !== fixa;
    },

    alteracaoFixaObsoleta() {
      if (!this.itn003IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.alteracaoImovelItn003;
      return fixa != null && this.ato?.alteracaoImovelItn003 != null
        && this.ato.alteracaoImovelItn003 !== fixa;
    },

    transmissaoPodeEditar() {
      if (!this.itn003IsFixa) return false;
      return this.ato?.classificacaoAtoItn003 === 'TRANSMISSAO_AQUISICAO_ORIGINARIA'
        && !this.ato?.transmissaoAquisicaoOriginaria;
    },

    alteracaoPodeEditar() {
      if (!this.itn003IsFixa) return false;
      return this.ato?.classificacaoAtoItn003 === 'ALTERACAO_IMOVEL'
        && !this.ato?.alteracaoImovelItn003;
    },

    itn004Livro2FixaObsoleta() {
      if (!this.itn004Livro2IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro2;
      return fixa != null && this.ato?.classificacaoAtoItn004Livro2 != null
        && this.ato.classificacaoAtoItn004Livro2 !== fixa;
    },

    itn004Livro2PodeEditar() {
      if (!this.itn004Livro2IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro2;
      return fixa != null && !this.ato?.classificacaoAtoItn004Livro2;
    },

    itn004Livro2IsDisabled() {
      return !this.edicao || (this.itn004Livro2IsFixa && !this.itn004Livro2FixaObsoleta && !this.itn004Livro2PodeEditar);
    },

    itn004Livro3FixaObsoleta() {
      if (!this.itn004Livro3IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro3;
      return fixa != null && this.ato?.classificacaoAtoItn004Livro3 != null
        && this.ato.classificacaoAtoItn004Livro3 !== fixa;
    },

    itn004Livro3PodeEditar() {
      if (!this.itn004Livro3IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro3;
      return fixa != null && !this.ato?.classificacaoAtoItn004Livro3;
    },

    itn004Livro3IsDisabled() {
      return !this.edicao || (this.itn004Livro3IsFixa && !this.itn004Livro3FixaObsoleta && !this.itn004Livro3PodeEditar);
    },

    tipoServicoOpcoes() {
      return this.ato?.tipoServico?.opcoes || {};
    },

    itn003Modo() {
      return this.tipoServicoOpcoes.classificacaoAtoItn003Modo;
    },
    itn003IsFixa() {
      // Modo ausente = Variável (padrão): só o 'FIXA' gravado explicitamente trava o campo.
      return this.itn003Modo === 'FIXA';
    },
    itn003IsVariavel() {
      return this.itn003Modo === 'VARIAVEL';
    },
    // Fixa apontando para "Nenhum" (ou sem valor) = o tipo de serviço declara que este ato não tem
    // classificação ITN 003. Aí o campo não aparece no ato e a simulação não cobra o preenchimento.
    // Atenção: NÃO dá para testar `ato.classificacaoAtoItn003 === 'NENHUM'` — `normalizarDependentesItn003`
    // grava NULL no ato para NENHUM, então quem sabe a intenção é a configuração do tipo de serviço.
    // E só esconde se o ato também não tem nada salvo: se tiver, é divergência de uma configuração
    // anterior e precisa continuar visível para o usuário resolver.
    itn003SemClassificacaoConfigurada() {
      if (!this.itn003IsFixa) return false;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn003;
      if (fixa && fixa !== 'NENHUM') return false;
      return !this.ato?.classificacaoAtoItn003;
    },
    itn003Options() {
      const baseOpts = [
        { id: 'NENHUM', nome: 'Nenhum' },
        { id: 'ABERTURA_MATRICULA', nome: '1 - Abertura de matrícula' },
        { id: 'ABERTURA_MATRICULA_OFICIO', nome: '2 - Abertura de matrícula (ofício/decisão judicial)' },
        { id: 'ALTERACAO_RELACAO_JURIDICA', nome: '3 - Alteração da relação jurídica' },
        { id: 'TRANSMISSAO_AQUISICAO_ORIGINARIA', nome: '4 - Transmissão-Aquisição Originária de Direitos Reais' },
        { id: 'ALTERACAO_IMOVEL', nome: '5 - Alteração do imóvel' },
        { id: 'OUTRO', nome: '6 - Outro' },
      ];
      if (this.itn003IsVariavel) {
        const allowed = this.tipoServicoOpcoes.classificacaoAtoItn003OpcoesDisponiveis || [];
        // Sem opções configuradas = sem restrição: todas ficam disponíveis para escolha.
        if (!allowed.length) return baseOpts;
        const set = new Set(allowed);
        const result = baseOpts.filter(o => set.has(o.id));
        const saved = this.ato?.classificacaoAtoItn003;
        if (saved && !result.some(o => o.id === saved)) {
          const savedOpt = baseOpts.find(o => o.id === saved);
          if (savedOpt) result.push(savedOpt);
        }
        return result;
      }
      if (this.itn003IsFixa) {
        const fixa = this.tipoServicoOpcoes.classificacaoAtoItn003;
        if (fixa) {
          const fixaOpt = baseOpts.find(o => o.id === fixa);
          if (this.itn003FixaObsoleta) {
            const savedId = this.ato?.classificacaoAtoItn003;
            const savedOpt = savedId ? baseOpts.find(o => o.id === savedId) : null;
            const opts = [];
            if (savedOpt) opts.push(savedOpt);
            if (fixaOpt) opts.push(fixaOpt);
            return opts;
          }
          if (fixaOpt) return [fixaOpt];
        }
      }
      return baseOpts;
    },

    transmissaoOptions() {
      if (this.itn003IsVariavel) {
        const disponiveis = this.tipoServicoOpcoes.transmissaoAquisicaoOriginariaOpcoesDisponiveis || [];
        // Sem opções configuradas = sem restrição: todas ficam disponíveis para escolha.
        if (!disponiveis.length) return transmissaoBaseOptions;
        const allowed = new Set(disponiveis);
        const result = transmissaoBaseOptions.filter(o => allowed.has(o.id));
        const saved = this.ato?.transmissaoAquisicaoOriginaria;
        if (saved && !result.some(o => o.id === saved)) {
          const savedOpt = transmissaoBaseOptions.find(o => o.id === saved);
          if (savedOpt) result.push(savedOpt);
        }
        return result;
      }
      if (this.itn003IsFixa) {
        const fixa = this.tipoServicoOpcoes.transmissaoAquisicaoOriginaria;
        const fixaOpt = fixa ? transmissaoBaseOptions.find(o => o.id === fixa) : null;
        const savedId = this.ato?.transmissaoAquisicaoOriginaria;
        // Mesmo sem valor FIXO configurado para este subcampo, o que já estava salvo continua
        // aparecendo — nunca fica em branco por falta de configuração no tipo de serviço.
        const savedOpt = savedId && savedId !== fixa ? transmissaoBaseOptions.find(o => o.id === savedId) : null;
        const opts = [];
        if (savedOpt) opts.push(savedOpt);
        if (fixaOpt) opts.push(fixaOpt);
        return opts;
      }
      return transmissaoBaseOptions;
    },

    alteracaoOptions() {
      if (this.itn003IsVariavel) {
        const disponiveis = this.tipoServicoOpcoes.alteracaoImovelItn003OpcoesDisponiveis || [];
        // Sem opções configuradas = sem restrição: todas ficam disponíveis para escolha.
        if (!disponiveis.length) return alteracaoBaseOptions;
        const allowed = new Set(disponiveis);
        const result = alteracaoBaseOptions.filter(o => allowed.has(o.id));
        const saved = this.ato?.alteracaoImovelItn003;
        if (saved && !result.some(o => o.id === saved)) {
          const savedOpt = alteracaoBaseOptions.find(o => o.id === saved);
          if (savedOpt) result.push(savedOpt);
        }
        return result;
      }
      if (this.itn003IsFixa) {
        const fixa = this.tipoServicoOpcoes.alteracaoImovelItn003;
        const fixaOpt = fixa ? alteracaoBaseOptions.find(o => o.id === fixa) : null;
        const savedId = this.ato?.alteracaoImovelItn003;
        // Mesmo sem valor FIXO configurado para este subcampo, o que já estava salvo continua
        // aparecendo — nunca fica em branco por falta de configuração no tipo de serviço.
        const savedOpt = savedId && savedId !== fixa ? alteracaoBaseOptions.find(o => o.id === savedId) : null;
        const opts = [];
        if (savedOpt) opts.push(savedOpt);
        if (fixaOpt) opts.push(fixaOpt);
        return opts;
      }
      return alteracaoBaseOptions;
    },

    itn004Livro2Modo() {
      return this.tipoServicoOpcoes.classificacaoAtoItn004Livro2Modo;
    },
    itn004Livro2IsFixa() {
      // Modo ausente = Variável (padrão): só o 'FIXA' gravado explicitamente trava o campo.
      return this.itn004Livro2Modo === 'FIXA';
    },
    itn004Livro2IsVariavel() {
      return this.itn004Livro2Modo === 'VARIAVEL';
    },
    itn004Livro2AllowedCodes() {
      if (this.itn004Livro2IsVariavel) {
        const disponiveis = this.tipoServicoOpcoes.classificacaoAtoItn004Livro2OpcoesDisponiveis || [];
        // Sem opções configuradas = sem restrição (null); só o valor salvo restringiria a lista.
        if (!disponiveis.length) return null;
        const codes = [...disponiveis];
        const saved = this.ato?.classificacaoAtoItn004Livro2;
        if (saved && !codes.includes(saved)) codes.push(saved);
        return codes;
      }
      if (this.itn004Livro2IsFixa && (this.itn004Livro2FixaObsoleta || this.itn004Livro2PodeEditar)) {
        const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro2;
        return fixa ? [fixa] : null;
      }
      return null;
    },

    itn004Livro3Modo() {
      return this.tipoServicoOpcoes.classificacaoAtoItn004Livro3Modo;
    },
    itn004Livro3IsFixa() {
      // Modo ausente = Variável (padrão): só o 'FIXA' gravado explicitamente trava o campo.
      return this.itn004Livro3Modo === 'FIXA';
    },
    itn004Livro3IsVariavel() {
      return this.itn004Livro3Modo === 'VARIAVEL';
    },
    itn004Livro3AllowedCodes() {
      if (this.itn004Livro3IsVariavel) {
        const disponiveis = this.tipoServicoOpcoes.classificacaoAtoItn004Livro3OpcoesDisponiveis || [];
        // Sem opções configuradas = sem restrição (null); só o valor salvo restringiria a lista.
        if (!disponiveis.length) return null;
        const codes = [...disponiveis];
        const saved = this.ato?.classificacaoAtoItn004Livro3;
        if (saved && !codes.includes(saved)) codes.push(saved);
        return codes;
      }
      if (this.itn004Livro3IsFixa && (this.itn004Livro3FixaObsoleta || this.itn004Livro3PodeEditar)) {
        const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro3;
        return fixa ? [fixa] : null;
      }
      return null;
    },

    hasLivro2() {
      return ['MATRICULA', 'TRANSCRICAO'].includes(this.ato?.livro);
    },

    hasLivro3() {
      return this.ato?.livro === 'REGISTRO_AUXILIAR';
    },

    isAtoGenericoLivro2() {
      return this.ato.classificacaoAtoItn004Livro2
        && this.ato.classificacaoAtoItn004Livro2.endsWith(SUFIXO_CLASSIFICACAO_ITN004_GENERICA);
    },

    isAtoGenericoLivro3() {
      return this.ato.classificacaoAtoItn004Livro3
        && this.ato.classificacaoAtoItn004Livro3.endsWith(SUFIXO_CLASSIFICACAO_ITN004_GENERICA);
    },

    mostrarBlocoIndicadorReal() {
      return this.hasLivro2;
    },

    exibirAutorizacaoIncra() {
      const classificacao = this.ato.classificacaoAtoItn003;
      return classificacao && classificacao !== 'NENHUM'
        && this.ficha?.categoria === 'RURAL'
        && AtoBusiness.getEnvolvidosEstrangeiros(this.ato.envolvidos).length > 0;
    },
  },

  watch: {
    'ato.classificacaoAtoItn004Livro2'(newVal, oldVal) {
      if (!this.edicao || !this.itn004Livro2IsFixa || newVal === oldVal) return;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro2;
      if (!newVal || newVal !== fixa) return;
      this.ato.denominacaoComplementarItn004Livro2 = this.tipoServicoOpcoes.denominacaoComplementarItn004Livro2 || null;
    },
    'ato.classificacaoAtoItn004Livro3'(newVal, oldVal) {
      if (!this.edicao || !this.itn004Livro3IsFixa || newVal === oldVal) return;
      const fixa = this.tipoServicoOpcoes.classificacaoAtoItn004Livro3;
      if (!newVal || newVal !== fixa) return;
      this.ato.denominacaoComplementarItn004Livro3 = this.tipoServicoOpcoes.denominacaoComplementarItn004Livro3 || null;
    },
  },
}
</script>

<style lang="scss" scoped>
.is-disabled-cursor {
  cursor: not-allowed;
}
</style>

